import ImageCollectionPage from "../components/ImageCollectionPage";

export default function GovernmentProperties() {
  return (
    <ImageCollectionPage 
      title="All Government Properties" 
      path="/properties" 
      collection="properties" 
    />
  );
}
